module.exports = __webpack_public_path__ + "@/assets/img/koku-pembe.c2ae0ac8.jpeg";